import { useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'tab',
    viewPath: props.viewPath,
  })
  return function onClick() {
    change(next => {
      next.selected.filters = {
        automation_type: null,
        type: null,
        status: null,
        search_term: null,
        value_to: [],
        appointment_type_ids: [],
      }
    })
  }
}
